SupportV2CurrentOrderView = require('./v2_current_order_view')
SupportServiceActionMainView = require('./service_action_main_view')

class SupportVerticalCurrentOrderView extends SupportV2CurrentOrderView

  createServiceActionView: ->
    @serviceActionMain = new SupportServiceActionMainView({
      showOnlyLinks: true
    })

  layoutView:() ->
    @orderSummary.$el.addClass('four columns')
    @dealSummary.$el.addClass('five columns')
    $('.deal-image', @dealSummary.$el).addClass('four columns')
    $('.deal-info', @dealSummary.$el).addClass('eight columns')
    @$el.append(@dealSummary.el)
    @$el.append(@orderSummary.el)
    unless @options.hideSelfServiceActions
      @serviceActionMain.$el.addClass('three columns divider')
      @$el.append(@serviceActionMain.el)

module.exports = SupportVerticalCurrentOrderView
